import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      backgroundColor: 'var(--white)',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{
        color: 'var(--dark-blue)',
        textAlign: 'center',
        marginBottom: '30px',
        fontSize: '32px'
      }}>
        Terms & Services
      </h1>
      
      <div style={{ marginBottom: '20px', textAlign: 'center', color: 'var(--gray-dark)' }}>
        <p><strong>Effective Date:</strong> January 29, 2026</p>
        <p><strong>Last Updated:</strong> January 29, 2026</p>
      </div>

      <div style={{ fontSize: '16px' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the CalorienSweat application ("App", "Service"), you agree to be bound by these Terms & Services ("Terms").
            If you do not agree, please do not use the App.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>2. Description of Services</h2>
          <p>CalorienSweat is a wellness platform that helps users:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li>Track fitness and nutrition programs</li>
            <li>Interact with assigned coaches</li>
            <li>Receive service-related notifications via WhatsApp and other channels</li>
          </ul>
          <p>The App is intended for personal wellness purposes only.</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>3. Eligibility</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>You must be 18 years or older to use this App</li>
            <li>By using the App, you confirm that the information you provide is accurate</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>4. User Accounts</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>You are responsible for maintaining the confidentiality of your account credentials</li>
            <li>You agree not to share your account with others</li>
            <li>You are responsible for all activities conducted under your account</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>5. WhatsApp Communication</h2>
          <p>By providing your phone number, you consent to receive:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li>Program updates</li>
            <li>Reminders</li>
            <li>Account-related notifications</li>
          </ul>
          <p>You may opt out anytime by replying STOP or contacting us.</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>6. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul style={{ marginLeft: '20px' }}>
            <li>Use the App for unlawful purposes</li>
            <li>Abuse, harass, or spam other users or coaches</li>
            <li>Attempt to gain unauthorized access to systems or data</li>
            <li>Misuse WhatsApp messaging or automation</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>7. Health Disclaimer</h2>
          <p>CalorienSweat:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
            <li>Does not provide medical advice</li>
            <li>Does not replace professional healthcare services</li>
            <li>All wellness content is informational only</li>
          </ul>
          <p>You should consult a qualified professional before making health decisions.</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>8. Intellectual Property</h2>
          <p>
            All content, branding, logos, and software belong to CalorienSweat.
            You may not copy, modify, or distribute any content without permission.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>9. Account Suspension or Termination</h2>
          <p>We reserve the right to:</p>
          <ul style={{ marginLeft: '20px' }}>
            <li>Suspend or terminate accounts for misuse or violation of these Terms</li>
            <li>Restrict access to protect platform security</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>10. Limitation of Liability</h2>
          <p>To the maximum extent permitted by Indian law:</p>
          <ul style={{ marginLeft: '20px' }}>
            <li>CalorienSweat shall not be liable for indirect or consequential damages</li>
            <li>Use of the App is at your own risk</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>11. Privacy</h2>
          <p>
            Your use of the App is governed by our Privacy Policy, which explains how we collect and process personal data.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>12. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time.
            Continued use of the App indicates acceptance of updated Terms.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>13. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India.
            Any disputes shall be subject to courts located in India.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>14. Contact Information</h2>
          <div style={{ 
            backgroundColor: 'var(--pale-blue)', 
            padding: '20px', 
            borderRadius: '8px',
            marginTop: '15px'
          }}>
            <p><strong>CalorienSweat</strong></p>
            <p>📧 Email: info@mindyards.com</p>
            <p>📍 Location: C-1203,Vastu River Nest, Ravet Pune 412101</p>
          </div>
        </section>

        <div style={{ 
          textAlign: 'center', 
          marginTop: '40px', 
          padding: '20px',
          backgroundColor: 'var(--gray-light)',
          borderRadius: '8px',
          fontSize: '14px',
          color: 'var(--gray-dark)'
        }}>
          <p>
            These Terms & Services are effective as of January 29, 2026, and apply to all users of the CalorienSweat platform.
          </p>
          <p>
            For the most current version of our Terms & Services, please visit this page regularly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
